import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from './theme/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './common/loader.service';
import { HTTPStatus } from './security/app.HttpListener';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user/user.services';
import { filter } from 'rxjs/operators';
import { SharedService } from './utils/shared.service';
import * as CommonConstants from 'src/app/utils/common.constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from './common/custom-validators/must-match.validator';
import swal from 'sweetalert2';
import { ChangePassword } from './change-password/change-password';
import { HttpClient, HttpResponse } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'nazouki-app';
  authenticated = false;
  toggleMenu = true;
  menuList: any;
  selected: any;
  selectedsub: any;
  showLoader: boolean;
  HTTPActivity: boolean;
logeedUserName;
  headerReqirements: BehaviorSubject<Object> = new BehaviorSubject<Object>(null);
  loadComponentHeader: boolean = false;
  partnerType: string;
  form: FormGroup;
  submitted: boolean;
  urlLogo='';//localStorage.getItem("ORG_LOGO");
  // themes = [{'name': 'theme-default'}, {'name': 'theme-dark'}];
  // selectedTheme = this.themes[1];
  password: ChangePassword = new ChangePassword();
  constructor(private router: Router, private themeService: ThemeService, private translate: TranslateService,
    private loaderService: LoaderService, private httpStatus: HTTPStatus, private userService: UserService, private sharedService: SharedService,private modal: NgbModal,private formBuilder: FormBuilder,private http: HttpClient) {

    this.httpStatus.getHttpStatus().subscribe(status => {
      this.HTTPActivity = status;
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart)
      ).subscribe(e => {
        if (e instanceof NavigationStart) {
          if (e.url !== '/login') {
            if (!userService.isAuthenticated()) {
              this.authenticated = false;
              router.navigate(['/login']);
            } else {
              this.authenticated = true;
              this.menuList=this.userService.getMenuList();
              this.logeedUserName=localStorage.getItem(CommonConstants.EMPLOYEE_NAME);
              this.partnerType=localStorage.getItem(CommonConstants.PARTNER_TYPE);
              this.sharedService.setUserOrganismId(+localStorage.getItem(CommonConstants.USER_ORGANISM));
            }
          }
          else if (e.url == '/login' && userService.isAuthenticated()) {
            this.partnerType=localStorage.getItem(CommonConstants.PARTNER_TYPE);
            if( +this.partnerType===2 || +this.partnerType===4){
              this.router.navigate(['myspace']);
            }else{
            this.router.navigate(['dashboard']);
            }
          }
        } /* else if (e.url == '/login' && userService.isAuthenticated()) {
                    router.navigate(['/dashboard']);
                } */


      });
    })
    translate.setDefaultLang('en');
    translate.addLangs(['en', 'fr']);

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    this.getFromGroup();
  }

  ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    if(localStorage.getItem(CommonConstants.USER_ORGANISM)!=null){
    this.http.get(CommonConstants.env + 'api/master/image/' +CommonConstants.PARTNER_ORGANISM_TYPE+'/'+localStorage.getItem(CommonConstants.USER_ORGANISM)).subscribe(res => {
      if (res['code'] == 'S0000') {
        let response = res['result'];
        if (response['image'] != null) {
          this.urlLogo='data:image/png;base64,' + response['image'];
        } else {
          this.urlLogo='';
        }
      } else {
        this.urlLogo='';
      }

    })
  } else {
    console.log("Organization logo not loaded..");
  }
  }


  authenticate() {
    this.authenticated = true;
  }
  showSidebar() {
    this.toggleMenu = !this.toggleMenu;
  }

  logout() {
    localStorage.clear();
    this.sharedService.setAuthenticated(false);
    this.authenticated = false;
    this.router.navigateByUrl('/login');
  }
  select(item) {
    this.selected = (this.selected === item ? null : item);
  }

  isActive(item) {
    return this.selected === item;
  }

  selectSub(item) {
    this.selectedsub = (this.selectedsub === item ? null : item);
  }
  isSubActive(item) {
    return this.selectedsub === item;
  }

  defaultTheme() {
    this.themeService.setTheme('standard');
  }
  classicTheme() {
    this.themeService.setTheme('classic');
  }
  optimisticTheme() {
    this.themeService.setTheme('optimistic');
  }
  royalTheme() {
    this.themeService.setTheme('royal');
  }

  changePasswordModal(changePassowrd) {
    this.getFromGroup();
    this.modal.open(changePassowrd, { container: '.page-content' });
  }

  get f() { return this.form.controls; }
  private getFromGroup() {
    this.form = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', Validators.required]
  }, {
      validator: MustMatch('newPassword', 'confirmPassword')
  });
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
        return false;
    }
   this.changePassword();
}
clear() {
  this.submitted = false;
  this.f.oldPassword = null;
  this.f.newPassword = null;
  this.f.confirmPassword = null;
  this.getFromGroup();
}
changePassword() {
  this.password = new ChangePassword();
  this.password.secUsrOldPswd=this.f.oldPassword.value;
  this.password.secUsrId=localStorage.getItem(CommonConstants.SEC_USER_ID);
  this.password.secUsrLogin=localStorage.getItem(CommonConstants.EMPLOYEE_NAME);
  this.password.secUsrPwd=this.f.newPassword.value;
  this.userService.changePassword(this.password).subscribe(res => {
      if (res['code'] == 0) {
          swal.fire('Saved!', res['message'], 'success')
          this.clear();
          this.modal.dismissAll();
          this.logout();
      }
      else {
          swal.fire('Saving Error : ', res['message'], 'error');
          this.clear();
      }
  });


}

  // toggle() {
  //   const active = this.themeService.getActiveTheme();
  //   if (active.name === 'light') {
  //     this.themeService.setTheme('dark');
  //   } else {
  //     this.themeService.setTheme('light');
  //   }
  // }

}
